export default {
  func: "function"
};